(() => {
  const BUNDLE_PROP = '_ghalia_stack_anchor';
  const FREE_GIFT_PROP = '_ghalia_free_gift';
  const ATTR_KEY = '_ghalia_non_bundle_net';

  const pricing = () => window.GhaliaPricing;

  const isFreeGiftLine = (item) => item?.properties?.[FREE_GIFT_PROP] === 'true';

  const isBundleLine = (item) => Boolean(item?.properties?.[BUNDLE_PROP]);

  const lineNetCents = (item, drawer) => {
    const P = pricing();
    if (!P) return Number(item?.final_line_price ?? item?.line_price ?? 0);
    const row = drawer?.querySelector(`[data-cart-line-key="${item.key}"]`);
    return P.cartLineAmounts(item, row).net;
  };

  const qualifyingSubtotalNet = (cart, drawer) => {
    const P = pricing();
    if (P?.qualifyingSubtotalNet) return P.qualifyingSubtotalNet(cart, drawer);
    let total = 0;
    (cart?.items || []).forEach((item) => {
      if (isFreeGiftLine(item) || isBundleLine(item)) return;
      total += lineNetCents(item, drawer);
    });
    return total;
  };

  const syncCartAttribute = async (cart, drawer) => {
    const net = qualifyingSubtotalNet(cart, drawer);
    const current = cart?.attributes?.[ATTR_KEY];
    if (current != null && Number(current) === net) return cart;
    const root = window.Shopify?.routes?.root || '/';
    try {
      const res = await fetch(`${root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          attributes: { ...(cart?.attributes || {}), [ATTR_KEY]: String(net) },
        }),
      });
      if (!res.ok) return cart;
      return res.json();
    } catch (err) {
      console.error(err);
      return cart;
    }
  };

  const NATIVE_BUNDLE_HANDLES =
    window.GhaliaNativeBundleHandles ||
    new Set([
      'ghalia-infinity-ring-duo',
      'knot-bridge-duo-silver',
      'knot-bridge-duo-gold',
      'ghalia-knot-hero-set-gold',
      'ghalia-knot-hero-set-silver',
      'ghalia-knot-two-tone-ring-stack',
      'ghalia-knot-wrist-story',
      'ghalia-pave-gold-stack',
      'ghalia-pave-silver-stack',
      'ghalia-cross-ring-earring-gold',
    ]);

  const hasNativeBundleLine = (cart) =>
    (cart?.items || []).some((item) => NATIVE_BUNDLE_HANDLES.has(item?.handle));

  const updatePromoNote = (drawer) => {
    const note = drawer?.querySelector('[data-cart-promo-bundle-note]');
    if (note) note.hidden = true;
  };

  let attrSyncTimer = null;
  let attrSyncChain = Promise.resolve();

  const scheduleAttributeSync = (cart, drawer) => {
    if (!cart?.items) return;
    clearTimeout(attrSyncTimer);
    attrSyncTimer = window.setTimeout(() => {
      const latest = window.GhaliaCart?.lastCart || cart;
      const liveDrawer = document.querySelector('[data-cart-drawer]');
      attrSyncChain = attrSyncChain
        .then(() => syncCartAttribute(latest, liveDrawer))
        .catch((err) => console.error(err));
    }, 800);
  };

  const apply = (cart) => {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!cart?.items) return;
    updatePromoNote(drawer);
    scheduleAttributeSync(cart, drawer);
  };

  const bind = () => {
    document.addEventListener('ghalia:cart-drawer:refreshed', () => {
      const cart = window.GhaliaCart?.lastCart;
      if (cart?.items) scheduleAttributeSync(cart, document.querySelector('[data-cart-drawer]'));
    });
    document.addEventListener('ghalia:cart:stack-discount', (e) => apply(e.detail?.cart));
  };

  window.GhaliaQualifyingBasket = {
    isBundleLine,
    isFreeGiftLine,
    qualifyingSubtotalNet,
    ATTR_KEY,
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
})();
